var BlockView = require('views/block/base-block-view');

var CustomView = BlockView.extend({
  initialize: function(options) {
    this.listenTo(this.model, 'change:state', (model, state) => {
      if(this.script && this.script[this.model.get(state)]) {
        _.bind(this.script[this.model.get(state)], this.script)(this);
      }
    });
    this.viewModel = kb.viewModel(this.model);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    ko.applyBindings(this.viewModel, this.el);
    this.delegate('click', '[data-complete]', this.readyToGo);
    if(this.model.get('completion_event')) {
      Chaplin.mediator.subscribe(this.model.get('completion_event'), this.readyToGo);
    }
  },
  play: function() {
    if(this.$('[data-complete]').length === 0 && !this.model.get('completion_event')) {
      this.readyToGo();
    }
  },
  getTemplateFunction: function() {
    return require(this.model.get('template'));
  }
});

module.exports = CustomView;